"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable consistent-return */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/newline-after-import */
/* eslint-disable import/no-default-export */
const react_1 = require("react");
const sdk_1 = __importDefault(require("@twa-dev/sdk"));
const react_router_1 = require("react-router");
const validatorus_react_1 = require("validatorus-react");
const react_i18next_1 = require("react-i18next");
const de_ui_1 = require("@delab-team/de-ui");
const passwordInput_1 = require("../../components/passwordInput");
const pswchange_module_css_1 = __importDefault(require("./pswchange.module.css"));
const pinpad_1 = require("../../components/pinpad");
const wallet_1 = require("../../logic/wallet");
const svg_selector_1 = require("../../assets/svg-selector");
const getClient_1 = require("../../utils/getClient");
// eslint-disable-next-line no-promise-executor-return
const delay = (delayInms) => new Promise(resolve => setTimeout(resolve, delayInms));
const ChangePsw = (props) => {
    const TgObj = sdk_1.default;
    const { t } = (0, react_i18next_1.useTranslation)();
    const wallet = new wallet_1.CustomWallet((0, getClient_1.getDeLabClient)());
    const [recoveryWords, setRecoveryWords] = (0, react_1.useState)(undefined);
    console.log(recoveryWords, 'recoveryWords');
    const navigate = (0, react_router_1.useNavigate)();
    const [position, setPosition] = (0, react_1.useState)(0);
    const [createAnimation, setCreateAnimation] = (0, react_1.useState)(undefined);
    const [createAnimationRepeat, setCreateAnimationRepeat] = (0, react_1.useState)(undefined);
    const pswOld = new validatorus_react_1.VldBuilder().with(validatorus_react_1.vlds.VLen, 8, 160).withFname('Password');
    const newPassword = new validatorus_react_1.VldBuilder()
        .with(validatorus_react_1.vlds.VNumber)
        .with(validatorus_react_1.vlds.VLen, 4, 4)
        .withFname('New Password');
    const newPasswordRepeat = new validatorus_react_1.VldBuilder()
        .with(validatorus_react_1.vlds.VNumber)
        .with(validatorus_react_1.vlds.VLen, 4, 4)
        .withFname('New Password');
    // const handleBack = () => {
    //     TgObj.HapticFeedback.impactOccurred('medium')
    //     TgObj.BackButton.hide()
    //     navigate('/')
    // }
    (0, react_1.useEffect)(() => {
        const setPincode = async () => {
            if (newPassword.value.length === 4) {
                setCreateAnimation('success');
                await delay(270);
                setPosition(2);
            }
        };
        setPincode();
    }, [newPassword.value]);
    console.log(newPassword.value, 'newPassword');
    (0, react_1.useEffect)(() => {
        const changePassword = async () => {
            if (newPassword.value === newPasswordRepeat.value && recoveryWords) {
                setCreateAnimationRepeat('success');
                await delay(150);
                const hash = await wallet_1.CustomWallet.KeyToHash(recoveryWords.join(' '), newPasswordRepeat.value);
                const loadData = await wallet.loadHashSaveData();
                console.log('CHANGE WALLET PSW');
                if (!hash || !loadData) {
                    return;
                }
                // save new hash in storage
                wallet.saveWallet({
                    iv: hash.iv,
                    hashFromKey: hash.hashFromKey,
                    publicKey: loadData.public,
                    address: loadData.address
                });
                wallet.setIsPincode();
                window.location.pathname = '/';
            }
            else if (newPassword.value !== newPasswordRepeat.value) {
                setCreateAnimationRepeat('failure');
            }
        };
        changePassword();
    }, [newPasswordRepeat.value]);
    (0, react_1.useLayoutEffect)(() => {
        window.document.body.scrollTo(0, 0);
    }, []);
    function enableBtn() {
        TgObj.MainButton.show();
        if (!pswOld.value || pswOld.value.length < 8) {
            TgObj.MainButton.disable();
            TgObj.MainButton.color = '#424B56';
            TgObj.MainButton.text = t('pincod.change-error');
        }
        else {
            TgObj.MainButton.enable();
            TgObj.MainButton.color = '#007AFF';
            TgObj.MainButton.text = t('pincod.change');
        }
    }
    const handleBackClick = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        if (position === 1) {
            newPassword.reset(true, true);
            setPosition(0);
            TgObj.BackButton.hide();
        }
        else if (position === 2) {
            setPosition(1);
            newPasswordRepeat.reset(true, true);
        }
    };
    (0, react_1.useEffect)(() => {
        TgObj.BackButton.show();
        if (position === 0) {
            TgObj.BackButton.hide();
            return;
        }
        TgObj.BackButton.onClick(handleBackClick);
        return () => {
            TgObj.BackButton.offClick(handleBackClick);
        };
    }, [position]);
    async function getMnemonic() {
        const res = await wallet.getPrivateKeys(pswOld.value);
        if (typeof res === 'object') {
            return alert(t('common.incorrect-password'));
        }
        setPosition(1);
        pswOld.reset(true, true);
        setRecoveryWords(res?.split(' '));
    }
    (0, react_1.useEffect)(() => {
        if (position !== 0) {
            TgObj.MainButton.hide();
            return;
        }
        enableBtn();
        const handleBtnClick = async () => {
            TgObj.HapticFeedback.impactOccurred('medium');
            if (position === 0) {
                return getMnemonic();
            }
        };
        TgObj.MainButton.onClick(handleBtnClick);
        return () => {
            TgObj.MainButton.offClick(handleBtnClick);
        };
    }, [position, pswOld]);
    const handleExit = () => {
        TgObj.HapticFeedback.impactOccurred('medium');
        if (window.confirm(t('common.are-you-sure'))) {
            wallet.exitWallet();
            window.location.pathname = '/reg';
        }
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [position === 0 && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: pswchange_module_css_1.default.title, children: t('pincod.change-title') }), (0, jsx_runtime_1.jsx)(passwordInput_1.PasswordInput, { inputTitle: t('common.enter-password') + ' (' + t('common.min-8') + ')', onChange: e => pswOld.change(e.target.value), placeholder: t('common.password') }), (0, jsx_runtime_1.jsxs)("div", { className: pswchange_module_css_1.default.infoWrapper, children: [(0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: pswchange_module_css_1.default.infoText, children: t('pincod.info') }), (0, jsx_runtime_1.jsx)("div", { className: pswchange_module_css_1.default.line }), (0, jsx_runtime_1.jsxs)("div", { className: pswchange_module_css_1.default.deployPanelInner, children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(svg_selector_1.SvgSelector, { id: "alert2" }) }), (0, jsx_runtime_1.jsx)(de_ui_1.Text, { className: `${pswchange_module_css_1.default.errorText} ${pswchange_module_css_1.default.warning}`, children: t('pincod.warning') })] }), (0, jsx_runtime_1.jsx)("button", { onClick: handleExit, className: pswchange_module_css_1.default.deployBtn, children: t('settings-modal.exit') })] })] }), position === 1 && (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(pinpad_1.PinPad, { title: t('pincod.create'), onChange: e => newPassword.change(e), animationState: createAnimation, setAnimationState: setCreateAnimation }) }), position === 2 && (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(pinpad_1.PinPad, { title: t('pincod.repeat'), onChange: e => newPasswordRepeat.change(e), animationState: createAnimationRepeat, setAnimationState: setCreateAnimationRepeat }) })] }));
};
exports.default = ChangePsw;
